import React from "react";
import "./AcademicQuestionBank.css";
import useScrollAnimation from "../constants/useScrollAnimation";

const QuestionBank = () => {
    const [headerRef, isHeaderVisible] = useScrollAnimation(0.2);
    const [contentRef, isContentVisible] = useScrollAnimation(0.2);

    return (
        <div id="question-bank" className="academic-qb-container">
            <div className="academic-qb-wrapper">
                <div ref={headerRef} className={`section-header ${isHeaderVisible ? "animate-in" : ""}`}>
                    <h2 className="academic-qb-title section-title-hm">QUESTION BANK</h2>
                </div>

                <div ref={contentRef} className={`schools-right ${isContentVisible ? "animate-in" : ""}`}>
                    <p className="academic-qb-subtitle">
                        Access comprehensive question banks designed to enhance learning and exam preparation, across all subjects and grade levels.
                    </p>

                    <div className="row">
                        <div className="col-md-6 col-lg-3 mb-4">
                            <div className="academic-qb-card">
                                <h4 className="academic-qb-card-title">Subject-wise Questions</h4>
                                <p className="tigps-main-question-bank-p">Comprehensive question sets for Mathematics, Science, English, and Social Studies.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3 mb-4">
                            <div className="academic-qb-card">
                                <h4 className="academic-qb-card-title">Previous Year Papers</h4>
                                <p className="tigps-main-question-bank-p">Access to CBSE board examination papers from the previous years.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3 mb-4">
                            <div className="academic-qb-card">
                                <h4 className="academic-qb-card-title">Mock Tests</h4>
                                <p className="tigps-main-question-bank-p">Regular practice tests, to assess progress and exam readiness.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3 mb-4">
                            <div className="academic-qb-card">
                                <h4 className="academic-qb-card-title">Sample Papers</h4>
                                <p className="tigps-main-question-bank-p">CBSE-patterned sample papers, for effective exam preparation.</p>
                            </div>
                        </div>
                    </div>

                    <div className="academic-qb-link-container">
                        <a
                            href="/question-bank"
                            rel="noopener noreferrer"
                            className="academic-qb-link"
                        >
                            Click here to open the Question Bank
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuestionBank;
